import * as React from 'react';

import { cn } from '@ui/lib/utils';

const textareaBaseClasses = [
  // layout
  'flex field-sizing-content min-h-16 w-full',
  // shape & colors
  'rounded-lg border border-input bg-background',
  // spacing & typography
  'px-2.5 py-2 text-base font-normal md:text-sm',
  // transitions & outline
  'transition-colors outline-none',
  // placeholder
  'placeholder:text-muted-foreground',
  // focus
  'focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50',
  // disabled
  'disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50',
  // invalid
  'aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20',
  // dark mode
  'dark:bg-input/30 dark:disabled:bg-input/80',
  'dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
].join(' ');

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentPropsWithoutRef<'textarea'>>(
  ({ className, ...props }, ref) => {
    return <textarea ref={ref} data-slot="textarea" className={cn(textareaBaseClasses, className)} {...props} />;
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
